import React from 'react'
import {Lang} from 'yougile-lang'
import {IconButton, LinkButton} from '@components/common/base/buttons'
import {UserNameBase} from '@components/common/base/user-name'
import {TwButtonsRow, TwCitedMessage, TwMessage} from './containers'
import {FileList} from './file-list'
import {CitedMessageProps} from './types'

export const CitedMessage = ({
  data,
  onClick,
  onClose,
  onDelete,
  heightRestricted,
  filesHeightRestricted,
  hoverable,
  className,
  onFileClick
}: CitedMessageProps) => (
  <TwCitedMessage
    onClick={onClick}
    $hoverable={hoverable}
    className={className}
  >
    <TwButtonsRow className="mb-8">
      <UserNameBase name={data.userName} type={data.userNameType} />
      {onClose && (
        <IconButton
          icon="IconX"
          size="small"
          wrapperSize="big"
          color="secondary"
          onClick={onClose}
          className="ml-auto -my-4 -mr-4"
        />
      )}
    </TwButtonsRow>
    {data.html && (
      <TwMessage
        $larger={data.emojiOnly}
        $heightRestricted={heightRestricted}
        dangerouslySetInnerHTML={{__html: data.html}}
        className="mb-8 last:mb-0"
      />
    )}
    {!!data.files?.length && (
      <FileList
        files={data.files}
        onClick={onFileClick}
        heightRestricted={filesHeightRestricted}
      />
    )}
    {onDelete && (
      <TwButtonsRow className="mt-8 py-4 !h-auto">
        <LinkButton
          icon="IconTrash"
          color="error"
          onClick={onDelete}
          noPaddings
        >
          {Lang.msg.deleteMsg}
        </LinkButton>
      </TwButtonsRow>
    )}
  </TwCitedMessage>
)
